<template>
  <div class="input-date-range-box" :style="boxStyle">
    <el-form :ref="refName" :model="dateForm" :rules="rules" :inline="true" :style="boxStyle" :class="{'lh40': formItem}">
      <el-form-item prop="myStrartTime">
        <el-date-picker
          class="inline-block-inp"
          v-model="dateForm.myStrartTime"
          :picker-options="startOptions"
          :type="type"
          size="small"
          :style="{width: width + 'px'}"
          :disabled="disabled"
          :value-format="valueFormat"
          :default-time="defalutTimeBegin"
          :default-value="defaultDate"
          placeholder="开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <span>至</span>
      </el-form-item>
      <el-form-item prop="myEndTime">
        <el-date-picker
        class="inline-block-inp"
          v-model="dateForm.myEndTime"
          :picker-options="endOptions"
          :type="type"
          size="small"
          :style="{width: width + 'px'}"
          :disabled="disabled"
          :value-format="valueFormat"
          default-time="23:59:59"
          :default-value="defaultDate"
          placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import { getSession, getSystemNewDate, formatTime } from '@/utils';
  /**
   * 限定最小时间不能大于最大时间
   * @displayName 时间范围选择器
   */
  export default {
    name: 'InputDateRange',
    props: {
      /**
       * 开始时间的值
      */
      startTime: {
        type: [Number, String],
        default: ''
      },
      /**
       * 结束时间的值
      */
      endTime: {
        type: [Number, String],
        default: ''
      },
      /**
       * 选择框的宽度
      */
      width: {
        type: [Number, String],
        default: 200
      },
      /**
       * 开始时间和结束时间拼合的数组，0开始时间，1结束时间
      */
      datesArr: {
        type: [Array, String],
        default: () => {
          return [];
        }
      },
      /**
       * 是否禁用
      */
      disabled: {
        type: Boolean,
        default: false
      },
      /**
       * @ignore
      */
      boxStyle: {
        type: String,
        default: ''
      },
      /**
       * 可选的最小时间
      */
      smallDate: {
        type: [String, Number],
        default: ''
      },
      /**
       * 可选的最大时间
      */
      bigDate: {
        type: [String, Number],
        default: ''
      },
      /**
       * 是否必填
      */
      required: {
        type: Boolean,
        default: true
      },
      /**
       * 是否在表单中
      */
      formItem: {
        type: Boolean,
        default: false
      },
      /**
       * ref的name值
      */
      refName: {
        type: String,
        default: ''
      },
      /**
       * 一个改变的时候就改变 datesArr
      */
      isOneChangeToChangDatesArr: {
        type: Boolean,
        default: false
      },
      /**
       * 是否只有当开始和结束时间都有值的时候才有 datesArr;
       * 当改属性为true；isOneChangeToChangDatesArr 不生效
      */
      isBothTwoHadValueToChange: {
        type: Boolean,
        default: false
      },
      /**
       * 时间选择框类型
       * @values year/month/date/week/ datetime/datetimerange/daterange
      */
      type: {
        type: String,
        default: 'datetime'
      },
      /**
       * 默认时间
      */
      defaultDate: {
        type: [Date, Number],
        default: () => {
          return new Date(getSession('newDateObj') && getSession('newDateObj').time);
        }
      },
      /**
       * 是否默认开始时间的时分秒
      */
      isDefaultTimeBegin: {
        type: Boolean,
        default: false
      },
      /**
       * 数据格式
       * @values timestamp yyyy-MM-dd HH:mm:ss
      */
      valueFormat: {
        type: String,
        default: 'timestamp'
      },
      // 选择最长时间跨度
      bigTimeSpan: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        // 开始时间
        // myStrartTime: this.startTime,
        startOptions: {
          disabledDate(time) {
            return false;
          }
        },
        // 结束时间
        // myEndTime: this.endTime,
        endOptions: {
          disabledDate(time) {
            return false;
          }
        },
        // 两个同时改变的数组
        dates: [],
        // 正则校验
        dateForm: {
          myStrartTime: this.startTime,
          myEndTime: this.endTime,
        },
        defalutTimeBegin: '00:00:00'
      };
    },
    beforeCreate() {
      getSystemNewDate();
    },
    watch: {
      defaultDate: {
        handler(val) {
          if (val && this.isDefaultTimeBegin) {
            // this.defalutTimeBegin = formatTime(val, 'hh:mm:ss');
            this.$set(this, 'defalutTimeBegin', formatTime(val, 'hh:mm:ss'));
          }
        },
        deep: true,
        immediate: true
      },
      smallDate: {
        handler(val) {
          // console.log('最小时间限制啦：', val, this.bigDate, (val > this.bigDate));
          let that = this;
          if (val && this.bigDate) {
            // 同时限制了开始和结束时间,如果最小时间大于最大时间，则全部可选
            // 同时限制了开始和结束时间,开始时间和结束时间都要同时限制最大和最小
            // 限制最小时间
            if (val > this.bigDate) {
              this.$set(this, 'startOptions', {
                disabledDate(time) {
                  return true;
                }
              });
              this.$set(this, 'endOptions', {
                disabledDate(time) {
                  return true;
                }
              });
            } else {
              let that = this;
              this.$set(this, 'startOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  return ((time < val) || (time > that.bigDate));
                }
              });
              this.$set(this, 'endOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  return ((time < val) || (time > that.bigDate));
                }
              });
            }
          } else if (val) {
            let changeVal = val;
            if (isNaN(val)) changeVal = (new Date(val)).getTime();
            this.$set(this, 'startOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                let b;
                if (that.dateForm.myEndTime) {
                  b = +that.dateForm.myEndTime;
                }
                if (b) {
                  return ((time < changeVal) || (time > b));
                } else {
                  return time < changeVal;
                }
              }
            });
            this.$set(this, 'endOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                let s = changeVal;
                if (that.dateForm.myStrartTime && that.dateForm.myStrartTime > changeVal) {
                  s = +that.dateForm.myStrartTime;
                }
                return time < s;
              }
            });
          }
        },
        deep: true,
        immediate: true
      },
      bigDate: {
        handler(val) {
          if (val && !this.smallDate) {
            let changeVal = val;
            if (isNaN(val)) changeVal = (new Date(val)).getTime();
            let that = this;
            this.$set(this, 'startOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                let b = changeVal;
                if (that.dateForm.myEndTime && that.dateForm.myEndTime < changeVal) {
                  b = +that.dateForm.myEndTime;
                }
                return time > b;
              }
            });
            this.$set(this, 'endOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                let s = null;
                let b = changeVal;
                if (that.dateForm.myStrartTime) {
                  s = +that.dateForm.myEndTime;
                }
                if (that.dateForm.endTime && that.dateForm.myEndTime < changeVal) {
                  b = +that.dateForm.myEndTime;
                }
                if (s) {
                  return ((time < s) || (time > b));
                } else {
                  return time > b;
                }
              }
            });
          }
        },
        deep: true,
        immediate: true
      },
      'dateForm.myStrartTime': {
        handler(val) {
          
          this.$emit('update:startTime', val || '');
  
          // 当开始和结束时间都有值的时候，dateaArr才能有值
          if (this.isBothTwoHadValueToChange) {
            if (val && this.dateForm.myEndTime) {
              this.$emit('update:datesArr', [val, this.dateForm.myEndTime]);
            } else if (!val) {
              this.$emit('update:datesArr', []);
            }
          } else if (this.isOneChangeToChangDatesArr) {
            // console.log('这里去更新时间啦啦啦');
            this.$emit('update:datesArr', [val || '', this.dateForm.myEndTime || '']);
          };

          /**
           * 当有一个值改变的时候，触发事件
           * @property {string} startTime 开始时间
           * @property {string} endTime 结束时间
           * @event onechange
          */
          this.$emit('onechange', val || '', this.dateForm.myEndTime || '');
          let that = this;
          if (val) {
            let changeVal = val;
            if (isNaN(val)) changeVal = (new Date(val)).getTime();
            // console.log(that.bigDate, '一开始没有触发这个修改吗妈妈妈妈妈妈', val, (that.smallDate && +that.smallDate > val), that.bigDate);
            this.$set(this, 'endOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                let bigTimeSpanTime = null;
                if (that.bigTimeSpan) {
                  bigTimeSpanTime = changeVal + that.bigTimeSpan;
                }
                let s;
                if (that.smallDate && +that.smallDate > changeVal) {
                  s = +that.smallDate;
                } else {
                  s = changeVal;
                }
                // console.log('开始时间修改：', time, s, that.smallDate, '比较：', time < s, time > that.bigDate);
                let timeBigData = that.bigDate;
                if (bigTimeSpanTime && bigTimeSpanTime < timeBigData) {
                  timeBigData = bigTimeSpanTime;
                }
                if (timeBigData) {
                  return (time < s || time > timeBigData);
                } else {
                  return time < s;
                }
              }
            });
          } else {
            // console.log('一开始没有触发这个修改吗妈妈妈妈妈妈22222222222');
            if (this.smallDate) {
              this.$set(this, 'endOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  if (that.bigDate) {
                    return time > that.bigDate || time < that.smallDate;
                  } else {
                    return time < that.smallDate;
                  }
                }
              });
              this.$set(this, 'startOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  let changeVal = that.dateForm.myEndTime;
                  if (isNaN(that.dateForm.myEndTime)) changeVal = (new Date(that.dateForm.myEndTime)).getTime();
                  let s;
                  if (changeVal && (!that.bigDate || (+that.bigDate > changeVal))) {
                    s = changeVal;
                  } else if (that.bigDate) {
                    s = +that.bigDate;
                  }
                  if (s) {
                    return time > s || time < that.smallDate;
                  } else {
                    return time < that.smallDate;
                  }
                }
              });
            } else {
              this.$set(this, 'endOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  if (that.bigDate) {
                    return time > that.bigDate;
                  } else {
                    return false;
                  }
                }
              });
            }
          };
          // 是否同时改变开始和结束时间
          if (val && this.dateForm.myEndTime) {
            this.$set(this, 'dates', [val, this.dateForm.myEndTime]);
          } else if (!val && !this.dateForm.myEndTime) {
            this.$set(this, 'dates', []);
          }
        },
        deep: true
      },
      'dateForm.myEndTime': {
        handler(val) {

          this.$emit('update:endTime', val || '');
          
          // 当开始和结束时间都有值的时候，dateaArr才能有值
          if (this.isBothTwoHadValueToChange) {
            if (val && this.dateForm.myStrartTime) {
              this.$emit('update:datesArr', [this.dateForm.myStrartTime, val]);
            } else if (!val) {
              this.$emit('update:datesArr', []);
            }
          } else if (this.isOneChangeToChangDatesArr) {
            this.$emit('update:datesArr', [this.dateForm.myStrartTime || '', val || '']);
          };
  
          this.$emit('onechange', this.dateForm.myStrartTime || '', val || '');
          let that = this;
          if (val) {
            let changeVal = val;
            if (isNaN(val)) changeVal = (new Date(val)).getTime();
            // console.log('结束时间控制开始时间啦啦啦啦啦：', val, (that.bigDate && +that.bigDate < val), that.smallDate);
            this.$set(this, 'startOptions', {
              disabledDate(timeInit) {
                let time = (new Date(timeInit)).getTime();
                // 最大可选的时间跨度
                let bigTimeSpanTime = null;
                let b;
                if (that.bigTimeSpan) {
                  bigTimeSpanTime = changeVal - that.bigTimeSpan;
                }
                if (that.bigDate && +that.bigDate < changeVal) {
                  b = +that.bigDate;
                } else {
                  b = changeVal;
                }
                let timeSmallDate = that.smallDate;
                if (bigTimeSpanTime && bigTimeSpanTime > timeSmallDate) {
                  timeSmallDate = bigTimeSpanTime;
                }
                if (timeSmallDate) {
                  return ((time < timeSmallDate) || (time > b));
                } else {
                  return time > b;
                }
              }
            });
          } else {
            // console.log('结束时间控制开始时间啦啦啦啦啦：2222222222222');
            if (this.bigDate) {
              this.$set(this, 'startOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  if (that.smallDate) {
                    return time < that.smallDate || time > that.bigDate;
                  } else {
                    return time > that.bigDate;
                  }
                }
              });
              this.$set(this, 'endOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  let s;
                  let changeVal = that.dateForm.myStrartTime;
                  if (isNaN(changeVal)) changeVal = (new Date(that.dateForm.myStrartTime)).getTime();
                  if (changeVal && +that.smallDate < changeVal) {
                    s = changeVal;
                  } else if (that.smallDate) {
                    s = +that.smallDate;
                  }
                  if (s) {
                    return time < s || time > that.bigDate;
                  } else {
                    return time > that.bigDate;
                  }
                }
              });
            } else {
              this.$set(this, 'startOptions', {
                disabledDate(timeInit) {
                  let time = (new Date(timeInit)).getTime();
                  if (that.smallDate) {
                    return time < that.smallDate;
                  } else {
                    return false;
                  }
                }
              });
            }
          };
          // 是否同时改变开始和结束时间
          if (val && this.dateForm.myStrartTime) {
            this.$set(this, 'dates', [this.dateForm.myStrartTime, val]);
          } else if (!val && !this.dateForm.myStrartTime) {
            this.$set(this, 'dates', []);
          }
        },
        deep: true
      },
      startTime: {
        handler(val) {
          this.dateForm.myStrartTime = val;
        },
        deep: true
      },
      endTime: {
        handler(val) {
          this.dateForm.myEndTime = val;
        },
        deep: true
      },
      datesArr: {
        handler(val) {
          if (val && val.length > 0) {
            this.dateForm.myStrartTime = val[0];
            this.dateForm.myEndTime = val[1];
          } else if (!this.startTime && !this.endTime) {
            this.dateForm.myStrartTime = '';
            this.dateForm.myEndTime = '';
          }
        },
        deep: true,
        immediate: true
      },
      dates: {
        handler(val) {
          this.$emit('update:datesArr', val);
          /**
           * 开始和结束时间均有值的时候，触发
           * @property {array} 开始和结束时间数组
           * @event bothchange
          */
          this.$emit('bothchange', val);
        },
        deep: true
      }
    },
    computed: {
      rules: function() {
        if (this.required) {
          return {
            myStrartTime: [
              { required: true, message: '请选择开始日期', trigger: 'change' },
            ],
            myEndTime: [
              { required: true, message: '请选择结束日期', trigger: 'change' },
            ]
          };
        } else {
          return {};
        }
      }
    },
    methods: {
      checkDateRange() {
        let isValid = false;
        this.$refs[this.refName].validate(function(valid) {
          isValid = valid;
          if (!valid) return false;
        });
        return isValid;
      },
      clearCalidate() {
        this.$refs[this.refName].clearValidate();
      }
    }
  };
</script>
<style scoped>
  .pd2{
    margin: 0 10px 0 0;
  }
  .inline-block-inp{
    display: inline-block;
    width: 200px;
  }
  .input-date-range-box{
    display: flex;
    align-items: center;
  }
  .input-date-range-box >>> .el-form-item{
    margin-bottom: 0;
  }
  .input-date-range-box >>> .el-form-item__content{
    line-height: 32px;
  }
  .lh40 >>> .el-form-item__content{
    line-height: 40px !important;
  }
</style>

